<template>
    <Select
        v-bind="$attrs"
        :model-value="data?.length ? modelValue : undefined"
        :options="data"
        value-field="id"
        label-field="name"
        :loading="isLoading"
        @input="$emit('update:modelValue', $event)"
    ></Select>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { useSemesters } from '@/queries/platformQueries';

/**
 * This component provides semester selection using our select component.
 */
export default defineComponent({
    name: 'SelectSemester',
    inheritAttrs: false,
    props: {
        /**
         * v-model semester id
         */
        modelValue: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
    },
    emits: ['update:modelValue'],
    setup() {
        const { data, isLoading } = useSemesters();

        return {
            data,
            isLoading,
        };
    },
});
</script>
